import { useQuery } from 'react-query';

import { getCacheSettings } from 'common/helpers';
import { getEmptyPage, IPaging, IQueryParameters } from 'common/models';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getAllUsersFilter, getUsers } from 'modules/settings/api';

interface IProps extends IPaging, IQueryParameters {}

export const useQueryUsers = ({ pageNo, pageSize, params }: IProps) => {
  const { data, isError, isLoading, isFetching, isFetched } = useQuery(
    [QUERY_KEYS.SETTINGS_PROFILE_USERS, pageNo, params],
    () =>
      getUsers({
        pageNo,
        pageSize,
        params,
      }),
    { ...getCacheSettings() },
  );

  const {
    data: allUsers,
    isLoading: allUsersIsLoading,
    isError: allUsersIsError,
  } = useQuery(QUERY_KEYS.SETTINGS_PROFILE_USERS_ROLE_FILTER, getAllUsersFilter);

  return {
    usersData: data || getEmptyPage(),
    allUsers: allUsers?.items,
    usersLoading: isLoading || allUsersIsLoading,
    usersError: isError || allUsersIsError,
    usersFetching: isFetching,
    usersFetched: isFetched,
  };
};
